import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './Auth.css';

export default function EarlyAccess() {
  const navigate = useNavigate();
  const { unlockEarlyAccess, logout } = useAuth();
  const [accessKey, setAccessKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await unlockEarlyAccess(accessKey);
      navigate('/play');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid access key. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/auth');
  };

  return (
    <div className="auth-container">
      <div className="auth-card card">
        <div className="auth-header">
          <h1>Early Access</h1>
          <p className="tagline">Welcome to the closed beta!</p>
        </div>

        <div className="early-access-info">
          <p>
            TomorrowDungeons is currently in closed beta testing.
            To access the game, please enter your early access key below.
          </p>
          <p className="early-access-note">
            Don't have a key? Follow us on social media for giveaways
            or join our Discord community.
          </p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="accessKey">Early Access Key</label>
            <input
              type="text"
              id="accessKey"
              value={accessKey}
              onChange={(e) => setAccessKey(e.target.value.toUpperCase())}
              placeholder="Enter your access key"
              autoComplete="off"
              autoFocus
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary auth-btn"
            disabled={loading || !accessKey.trim()}
          >
            {loading ? 'Verifying...' : 'Unlock Access'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Wrong account?</p>
          <button onClick={handleLogout} className="btn btn-link">
            Log out and try another account
          </button>
        </div>
      </div>
    </div>
  );
}
